import { axios } from './axios.js';

const SPATIAL_VISION_URL = '/spatial-vision';

export async function createSpatialVisionUploadUrl(payload) {
  const res = await axios.post(
    `${SPATIAL_VISION_URL}/uploads/presign`,
    payload,
  );
  return res.data.response;
}

export async function listSpatialVisionSequences() {
  const res = await axios.get(`${SPATIAL_VISION_URL}/sequences`);
  return res.data.response;
}

export async function createSpatialVisionSequence(payload) {
  const res = await axios.post(`${SPATIAL_VISION_URL}/sequences`, payload);
  return res.data.response;
}

export async function getSpatialVisionSequence(sequenceId) {
  const res = await axios.get(`${SPATIAL_VISION_URL}/sequences/${sequenceId}`);
  return res.data.response;
}

// The sequence's Conveyor conditions as the file the Jetson loads, reference photos inside. vlm: the VLM box on AWS
// reads the words; without it (the default) the backend assembles the file by patterns.
export async function exportSpatialVisionConveyor(sequenceId, { vlm = false } = {}) {
  const res = await axios.post(
    `${SPATIAL_VISION_URL}/sequences/${sequenceId}/conveyor-export`,
    { vlm },
    { timeout: 150000 },
  );
  return res.data.response;
}

export async function updateSpatialVisionSequence(sequenceId, payload) {
  const res = await axios.put(
    `${SPATIAL_VISION_URL}/sequences/${sequenceId}`,
    payload,
  );
  return res.data.response;
}

export async function deleteSpatialVisionSequence(sequenceId) {
  const res = await axios.delete(
    `${SPATIAL_VISION_URL}/sequences/${sequenceId}`,
  );
  return res.data.response;
}

export async function listSpatialVisionSteps(sequenceId) {
  const res = await axios.get(
    `${SPATIAL_VISION_URL}/sequences/${sequenceId}/steps`,
  );
  return res.data.response;
}

export async function createSpatialVisionStep(sequenceId, payload) {
  const res = await axios.post(
    `${SPATIAL_VISION_URL}/sequences/${sequenceId}/steps`,
    payload,
  );
  return res.data.response;
}

export async function updateSpatialVisionStep(sequenceId, stepId, payload) {
  const res = await axios.put(
    `${SPATIAL_VISION_URL}/sequences/${sequenceId}/steps/${stepId}`,
    payload,
  );
  return res.data.response;
}

export async function deleteSpatialVisionStep(sequenceId, stepId) {
  const res = await axios.delete(
    `${SPATIAL_VISION_URL}/sequences/${sequenceId}/steps/${stepId}`,
  );
  return res.data.response;
}

export async function reorderSpatialVisionSteps(sequenceId, steps) {
  const res = await axios.patch(
    `${SPATIAL_VISION_URL}/sequences/${sequenceId}/steps/reorder`,
    { steps },
  );
  return res.data.response;
}

export async function listSpatialVisionConditions(stepId) {
  const res = await axios.get(
    `${SPATIAL_VISION_URL}/steps/${stepId}/conditions`,
  );
  return res.data.response;
}

export async function createSpatialVisionCondition(stepId, payload) {
  const res = await axios.post(
    `${SPATIAL_VISION_URL}/steps/${stepId}/conditions`,
    payload,
  );
  return res.data.response;
}

export async function updateSpatialVisionCondition(
  stepId,
  conditionId,
  payload,
) {
  const res = await axios.put(
    `${SPATIAL_VISION_URL}/steps/${stepId}/conditions/${conditionId}`,
    payload,
  );
  return res.data.response;
}

export async function deleteSpatialVisionCondition(stepId, conditionId) {
  const res = await axios.delete(
    `${SPATIAL_VISION_URL}/steps/${stepId}/conditions/${conditionId}`,
  );
  return res.data.response;
}

export async function reorderSpatialVisionConditions(stepId, conditions) {
  const res = await axios.patch(
    `${SPATIAL_VISION_URL}/steps/${stepId}/conditions/reorder`,
    { conditions },
  );
  return res.data.response;
}

export async function createSpatialVisionReferenceImage(conditionId, payload) {
  const res = await axios.post(
    `${SPATIAL_VISION_URL}/conditions/${conditionId}/reference-image`,
    payload,
  );
  return res.data.response;
}

export async function replaceSpatialVisionReferenceImage(conditionId, payload) {
  const res = await axios.put(
    `${SPATIAL_VISION_URL}/conditions/${conditionId}/reference-image`,
    payload,
  );
  return res.data.response;
}

export async function deleteSpatialVisionReferenceImageById(
  conditionId,
  imageId,
) {
  const res = await axios.delete(
    `${SPATIAL_VISION_URL}/conditions/${conditionId}/reference-images/${imageId}`,
  );
  return res.data.response;
}

export async function updateSpatialVisionReferenceImageMarkers(
  conditionId,
  imageId,
  payload,
) {
  const res = await axios.patch(
    `${SPATIAL_VISION_URL}/conditions/${conditionId}/reference-images/${imageId}/markers`,
    payload,
  );
  return res.data.response;
}

export async function deleteSpatialVisionReferenceImage(conditionId) {
  const res = await axios.delete(
    `${SPATIAL_VISION_URL}/conditions/${conditionId}/reference-image`,
  );
  return res.data.response;
}

export async function testSpatialVisionCondition(conditionId, payload) {
  const res = await axios.post(
    `${SPATIAL_VISION_URL}/conditions/${conditionId}/test`,
    payload,
  );
  return res.data.response;
}

export async function testSpatialVisionStep(stepId, payload) {
  const res = await axios.post(
    `${SPATIAL_VISION_URL}/steps/${stepId}/test`,
    payload,
  );
  return res.data.response;
}

export async function runSpatialVisionSequence(sequenceId, payload) {
  const res = await axios.post(
    `${SPATIAL_VISION_URL}/sequences/${sequenceId}/run`,
    payload,
  );
  return res.data.response;
}

export async function createSpatialVisionDirectJob(payload) {
  const res = await axios.post(`${SPATIAL_VISION_URL}/jobs/direct`, payload);
  return res.data.response;
}

export async function createSpatialVisionSequenceJob(sequenceId, payload) {
  const res = await axios.post(
    `${SPATIAL_VISION_URL}/sequences/${sequenceId}/jobs`,
    payload,
  );
  return res.data.response;
}

export async function listSpatialVisionJobs(params) {
  const res = await axios.get(`${SPATIAL_VISION_URL}/jobs`, { params });
  return res.data.response;
}

export async function getSpatialVisionJob(jobId) {
  const res = await axios.get(`${SPATIAL_VISION_URL}/jobs/${jobId}`);
  return res.data.response;
}

export async function cancelSpatialVisionJob(jobId) {
  const res = await axios.post(`${SPATIAL_VISION_URL}/jobs/${jobId}/cancel`);
  return res.data.response;
}

export async function cancelSpatialVisionJobItem(jobId, itemId) {
  const res = await axios.post(
    `${SPATIAL_VISION_URL}/jobs/${jobId}/items/${itemId}/cancel`,
  );
  return res.data.response;
}

export async function runSpatialVisionChat(payload) {
  const res = await axios.post(`${SPATIAL_VISION_URL}/chat`, payload);
  return res.data.response;
}

export async function runSpatialVisionChatBatch(payload) {
  const res = await axios.post(`${SPATIAL_VISION_URL}/chat/batch`, payload);
  return res.data.response;
}

export async function listSpatialVisionSessions(params) {
  const res = await axios.get(`${SPATIAL_VISION_URL}/sessions`, { params });
  return res.data.response;
}

export async function getSpatialVisionSession(sessionId) {
  const res = await axios.get(`${SPATIAL_VISION_URL}/sessions/${sessionId}`);
  return res.data.response;
}

export async function deleteSpatialVisionSession(sessionId) {
  const res = await axios.delete(`${SPATIAL_VISION_URL}/sessions/${sessionId}`);
  return res.data.response;
}

export async function cancelSpatialVisionSession(sessionId) {
  const res = await axios.post(
    `${SPATIAL_VISION_URL}/sessions/${sessionId}/cancel`,
  );
  return res.data.response;
}

export async function cancelSpatialVisionBatch(batchId) {
  const res = await axios.post(
    `${SPATIAL_VISION_URL}/batches/${batchId}/cancel`,
  );
  return res.data.response;
}

export async function listSpatialVisionDetections(sessionId) {
  const res = await axios.get(
    `${SPATIAL_VISION_URL}/sessions/${sessionId}/detections`,
  );
  return res.data.response;
}

export async function getSpatialVisionDetection(detectionId) {
  const res = await axios.get(
    `${SPATIAL_VISION_URL}/detections/${detectionId}`,
  );
  return res.data.response;
}

export async function getSpatialVisionVlmVersions() {
  const res = await axios.get(`${SPATIAL_VISION_URL}/vlm-versions`);
  return res.data.response;
}

export async function getSpatialVisionSettings() {
  const res = await axios.get(`${SPATIAL_VISION_URL}/settings`);
  return res.data.response;
}

export async function updateSpatialVisionSettings(payload) {
  const res = await axios.put(`${SPATIAL_VISION_URL}/settings`, payload);
  return res.data.response;
}

export async function uploadSpatialVisionImage(file, purpose = 'input') {
  const extension = file.name.split('.').pop() || file.type.split('/').pop();
  const presign = await createSpatialVisionUploadUrl({
    filename: file.name,
    type: extension,
    purpose,
  });

  const res = await fetch(presign.uploadUrl, {
    method: 'PUT',
    body: file,
    headers: file.type ? { 'Content-Type': file.type } : {},
  });
  // a refused upload left a row pointing at a missing object
  if (!res.ok) throw new Error(`${file.name}: upload failed (${res.status})`);

  return presign.storageUrl;
}
